"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerHeaderClassNames: function() {
        return drawerHeaderClassNames;
    },
    useDrawerHeaderStyles_unstable: function() {
        return useDrawerHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerHeaderClassNames = {
    root: 'fui-DrawerHeader'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r3ovn4i", null, [
    ".r3ovn4i{width:100%;max-width:100%;padding:var(--spacingVerticalXXL) var(--spacingHorizontalXXL) var(--spacingVerticalS);gap:var(--spacingHorizontalS);align-self:stretch;display:flex;flex-direction:column;box-sizing:border-box;position:relative;z-index:2;}"
]);
const useDrawerHeaderStyles = /*#__PURE__*/ (0, _react.__styles)({
    separator: {
        mpb1vu: "f1bc0r91",
        Hdbjpj: "f11ef69",
        cnmfks: [
            "f15lyva8",
            "f1cvlmu2"
        ],
        jc51t6: [
            "f1cvlmu2",
            "f15lyva8"
        ],
        Bmyypfa: "f9pox2d",
        Bkbwdz4: "f1swzn7y",
        mafdb0: "f1pb4rwf",
        wbfbqe: "fsav6n4",
        Jgwf15: "f1iuoiuj",
        Bs6t6z0: "fqc6z8f",
        Bj55yzk: "fw2wsqs"
    },
    separatorVisible: {
        Bmyypfa: "frwhdur"
    }
}, {
    d: [
        ".f1bc0r91:after{height:1px;}",
        ".f11ef69:after{position:absolute;}",
        ".f15lyva8:after{right:0;}",
        ".f1cvlmu2:after{left:0;}",
        ".f9pox2d:after{opacity:0;}",
        ".f1swzn7y:after{background-color:var(--colorNeutralStroke1);}",
        ".f1pb4rwf:after{transition-duration:var(--durationNormal);}",
        ".fsav6n4:after{transition-property:opacity;}",
        ".f1iuoiuj:after{transition-timing-function:var(--curveEasyEase);}",
        ".fqc6z8f:after{content:\"\";}",
        ".fw2wsqs:after{bottom:0;}",
        ".frwhdur:after{opacity:1;}"
    ]
});
const useDrawerHeaderStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const rootStyles = useDrawerHeaderStyles();
    state.root.className = (0, _react.mergeClasses)(drawerHeaderClassNames.root, styles, state.scrollState !== 'none' && rootStyles.separator, [
        'middle',
        'bottom'
    ].includes(state.scrollState) && rootStyles.separatorVisible, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerHeaderStyles.styles.js.map
